import script from "./HeaderView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderView.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderView.vue?vue&type=style&index=0&id=1d5d966c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d5d966c"]])

export default __exports__